export default function validateDate(day, month, year) {
    if (!day || !month || !year) {
      return false;
    }
  
    const dayInt = parseInt(day, 10);
    const monthInt = parseInt(month, 10);
    const yearInt = parseInt(year.length === 2 ? "20" + year : year, 10);
  
    if (isNaN(dayInt) || isNaN(monthInt) || isNaN(yearInt)) {
      return false;
    }
  
    // Ensure valid month and reasonable year range
    if (monthInt < 1 || monthInt > 12 || dayInt < 1 || yearInt < 1900 || yearInt > 2099) {
      return false;
    }
  
    // Create a date object and verify normalization
    const date = new Date(yearInt, monthInt - 1, dayInt);
    
    return (
      date.getFullYear() === yearInt &&
      date.getMonth() === monthInt - 1 &&
      date.getDate() === dayInt
    );
};

export const validateDateString = (dateString) => {
  if (!dateString) return false;
  
  // Regular expression to match YYYY-MM-DD or YYYY/MM/DD
  const regex = /^(\d{4})[-/](0[1-9]|1[0-2])[-/](0[1-9]|[12]\d|3[01])$/;
  
  const match = dateString.match(regex);
  if (!match) return false;

  const [, year, month, day] = match.map(Number);

  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};
